/**
 * Screen-share-safe email masking (operator request 2026-06-13): emails are
 * redacted everywhere in the UI by default so a recorded demo never leaks an
 * address, with an eye toggle to reveal (see <RedactedEmail />).
 *
 * Format keeps just enough shape to stay recognizable to the owner:
 * info@replyorbuy.com -> in•••@r•••.com
 */
export function maskEmail(email: string): string {
  const at = email.indexOf('@');
  if (at <= 0) return '•••';
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  const lastDot = domain.lastIndexOf('.');
  const tld = lastDot > 0 ? domain.slice(lastDot) : '';
  const domainName = lastDot > 0 ? domain.slice(0, lastDot) : domain;
  return `${local.slice(0, 2)}•••@${domainName.charAt(0)}•••${tld}`;
}
